import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_BASE_URL;
const apikey = process.env.REACT_APP_API_KEY;

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    credentials: "include",
    prepareHeaders: (headers, { getState }) => {
      headers.set("apiKey", apikey);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),

  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({
        url: `/admin/login`,
        method: "POST",
        body,
      }),
    }),

    forgotpassword: builder.mutation({
      query: (body) => ({
        url: `/admin/forgotPassword`,
        method: "POST",
        body,
      }),
    }),

    resetpassword: builder.mutation({
      query: (body) => ({
        url: `/admin/resetPassword`,
        method: "POST",
        body,
      }),
    }),

  }),
});

export const { useLoginMutation, useForgotpasswordMutation, useResetpasswordMutation } = authApi;
